import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import Select from '../common/form/select';
import ColorUtils from '../common/colorUtils/ColorUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';

import { getLista, setFiltro, getListaUnidade, getListaProduto, getListaDistribuidora, getListaCidade } from './precoGeralActions';

class PrecoGeral extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
		this.props.getLista();
		this.props.getListaUnidade();
		this.props.getListaProduto();
		this.props.getListaDistribuidora();
		this.props.getListaCidade();
    }

    render() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {
			if ((this.props.filtro.ids_distribuidoras || []).length && !this.props.filtro.ids_distribuidoras.includes(item.id_distribuidora)) {
				return false;
			}
			if ((this.props.filtro.ids_cidades || []).length && !this.props.filtro.ids_cidades.includes(item.id_cidade)) {
				return false;
			}

			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<LabelAndInputMask
							label='Data' placeholder='Informe a data'
							cols='6 6 4 2'
							mask='99/99/9999'
							maxWidth={140}
							value={this.props.filtro.data}
							onChange={(data) => {
								this.props.setFiltro({ ...this.props.filtro, data: data.target.value });
								this.props.getLista();
							}} />

						<Select
							label='Unidade' placeholder='Selecione a unidade'
							cols='6 6 4 2'
							options={this.props.listaUnidade}
							value={this.props.filtro.id_unidade}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_unidade: value });
								this.props.getLista();
							}} />

						<Select
							label='Produto' placeholder='Selecione o produto'
							cols='6 6 4 2'
							options={this.props.listaProduto}
							value={this.props.filtro.id_produto}
							onChange={value => {
								this.props.setFiltro({ ...this.props.filtro, id_produto: value });
								this.props.getLista();
							}} />

						<Select
							label='Distribuidora' placeholder='Selecione a distribuidora'
							cols='6 6 4 2'
							multiple
							options={this.props.listaDistribuidora}
							value={this.props.listaDistribuidora.map(item => ({ value: item.id, label: item.valor })).filter(item => (this.props.filtro.ids_distribuidoras || []).includes(item.value))}
							onChange={values => {
								this.props.setFiltro({ ...this.props.filtro, ids_distribuidoras: (values || []).map(item => item.value) });
							}} />

						<Select
							label='Cidade' placeholder='Selecione o cidade'
							cols='6 6 4 2'
							multiple
							options={this.props.listaCidade}
							value={this.props.listaCidade.map(item => ({ value: item.id, label: item.valor })).filter(item => (this.props.filtro.ids_cidades || []).includes(item.value))}
							onChange={values => {								
								this.props.setFiltro({ ...this.props.filtro, ids_cidades: (values || []).map(item => item.value) });
							}} />

						<Grid cols='6 6 3 2' style={{ marginTop: 28 }}>
							<ExcelFile
								filename={'Preços'}
								element={
									<Button
										text='Exportar Excel'
										type={'success'}
										icon={'fa fa-chevron-left'} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									preco_dia: parseFloat(item.preco_dia || 0),
									preco_30: parseFloat(item.preco_30 || 0),
									preco_30_frete: parseFloat(item.preco_30_frete || 0),
									diferenca: lista[0] ? parseFloat(item.preco_30_frete || 0) - parseFloat(lista[0].preco_30_frete || 0) : 0 || 0
								}))} name={'Preços'}>
									<ExcelColumn label='Distribuidora' value='nome_distribuidora' />
									<ExcelColumn label='Cidade' value='nome_cidade' />
									<ExcelColumn label='Preço Original' value='preco_dia' type='number' />
									<ExcelColumn label='Preço 30 dias' value='preco_30' type='number' />
									<ExcelColumn label='Preço 30 dias + frete' value='preco_30_frete' type='number' />
									<ExcelColumn label='Diferença' value='diferenca' type='number' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th width={200}>Distribuidora</Th>
								<Th width={200}>Cidade</Th>
								<Th width={100} alignCenter>Preço Original 
									<i class='fas fa-sort-amount-down'
										style={{ marginLeft: 4, color: this.props.filtro.ordem == 'preco_dia' ? null : '#d3d3d3' }}
										onClick={() => {
											this.props.setFiltro({ ...this.props.filtro, ordem: 'preco_dia' });
											this.props.getLista();
										}}>
									</i>
								</Th>
								<Th width={100} alignCenter>Preço 30 dias 
									<i class='fas fa-sort-amount-down'
										style={{ marginLeft: 4, color: this.props.filtro.ordem == 'preco_30' ? null : '#d3d3d3' }}
										onClick={() => {
											this.props.setFiltro({ ...this.props.filtro, ordem: 'preco_30' });
											this.props.getLista();
										}}>
									</i>
								</Th>
								<Th width={100} alignCenter>Preço 30 dias + frete
									<i class='fas fa-sort-amount-down'
										style={{ marginLeft: 4, color: this.props.filtro.ordem == 'preco_30_frete' ? null : '#d3d3d3' }}
										onClick={() => {
											this.props.setFiltro({ ...this.props.filtro, ordem: 'preco_30_frete' });
											this.props.getLista();
										}}>
									</i>
								</Th>
								<Th width={100} alignCenter>Diferença</Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => {
								
								let melhor = lista[0];

								return (
									<Tr key={item.id} >
										<Td minWidth={200}>{item.nome_distribuidora}</Td>
										<Td minWidth={200}>{item.nome_cidade}</Td>
										<Td minWidth={100} alignCenter>{FormatUtils.formatarValorTela(item.preco_dia, 4)}</Td>
										<Td minWidth={100} alignCenter>{FormatUtils.formatarValorTela(item.preco_30, 4)}</Td>
										<Td minWidth={100} alignCenter>{FormatUtils.formatarValorTela(item.preco_30_frete, 4)}</Td>
										<Td minWidth={100} alignCenter>{FormatUtils.formatarValorTela(melhor ? parseFloat(item.preco_30_frete || 0) - parseFloat(melhor.preco_30_frete || 0) : 0, 4)}</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	lista: state.precoGeral.lista,
	filtro: state.precoGeral.filtro,
	listaUnidade: state.precoGeral.listaUnidade,
	listaProduto: state.precoGeral.listaProduto,
	listaDistribuidora: state.precoGeral.listaDistribuidora,
	listaCidade: state.precoGeral.listaCidade
});
const mapDispatchToProps = dispatch => bindActionCreators({ getLista, setFiltro, getListaUnidade, getListaProduto, getListaDistribuidora, getListaCidade }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PrecoGeral);
